// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"571361eb","332":"40994722","679":"4948ec00","789":"904b8964","827":"09ad7317"}[chunkId] + ".chunk.css";
};